import { render } from "./GetIncomePopup.vue?vue&type=template&id=e29afb5a&scoped=true"
import script from "./GetIncomePopup.vue?vue&type=script&lang=js"
export * from "./GetIncomePopup.vue?vue&type=script&lang=js"

import "./GetIncomePopup.vue?vue&type=style&index=0&id=e29afb5a&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29afb5a"]])

export default __exports__